module.exports = __webpack_public_path__ + "img/title3.ebce2a94.png";